import { WEB_URL } from "../../api/URLs";

export const frequentQuestions = [
    {
        type: 'General Questions',
        data: [
            {
                question: 'What is The Citizens Foundation (TCF)?',
                answer: `The Citizens Foundation (TCF) is a professionally managed non-profit organization set up in 1995 by a
                group of citizens who wanted to bring about positive social change through education. Today, TCF is one
                of Pakistan’s leading organizations in the field of education, with over 280,000 children enrolled in its
                1,833 schools built to cater to the most deprived communities in Pakistan.
                <br/><br/>
                The TCF school curriculum promotes an interactive, child centered teaching approach with emphasis on
                hands-on activities that help children learn, question and enjoy the education process. Through the power
                of quality education TCF is enabling moral, spiritual and intellectual enlightenment of Pakistan's
                children.`
            },
            {
                question: 'I am having difficulty finding specific information. What do I do?',
                answer: 'Please send an email message at: <a href="mailto:contact@tcfglobal.org">contact@tcfglobal.org</a>'
            },
            {
                question: 'How does TCF calculate impact?',
                answer: `TCF defines your donation's impact in terms of the number of children it helps in sending to school. It is
                calculated by dividing the donated amount by the amount it takes to support one child's education.
                <br/><br/>
                Your impact is automatically calculated as soon as a donation comes in. The impact calculated can be found on the fundraising page, under the amount raised.`
            },
            {
                question: 'How does TCF keep my data safe?',
                answer: `The Citizens Foundation takes several steps to protect customer data. This is a collaborative effort to
                identify and mitigate risks and implement best practices.
                <br/><br/>
                To help prevent unauthorized access, maintain data accuracy, and ensure the correct use of
                information, we have put in place appropriate, electronic, and managerial procedures to safeguard and
                secure the information we collect. We also use industry accepted tools and techniques such as SSL and
                two-factor authentication to protect against unauthorized access to our systems. Additionally, all
                sensitive information is stored in secure repositories in secure cloud-based web apps.
                <br/><br/>
                The Citizens Foundation's infrastructure is hosted with Amazon Web Services. AWS maintains multiple
                certifications for its data centers, including ISO 27001 compliance and PCI DSS Certification. In addition,
                infrastructure is configured by code & configuration management systems. This enables quick
                restoration of failed infrastructure. Full and incremental backups are maintained for critical data &
                infrastructure. For more information about their certification and compliance, please visit the AWS
                Security Website.`
            },
            {
                question: 'Does TCF only operate in Pakistan?',
                answer: 'All funds raised will go to Pakistan for supporting the education of children and the building of schools.'
            }
        ],
    },
    {
        type: 'Questions about Fundraising',
        data: [
            {
                question: 'How can I fundraise for TCF?',
                answer: `Any funds raised go directly to TCF to support children's education and help build schools. Donations can
                be made by either contributing to an existing fundraiser or creating a new one. Follow the steps below to create a fundraiser:
                <br/><br/>
                <ul>
                    <li>On the main page click on: <a href="${WEB_URL.CREATE_FUNDRAISER}">“Start Your fundraiser”</a></br></li>
                    <li>Create an account</li>
                    <li>Input your basic information, i.e. preferred name for your page, your fundraising goal.</li>
                    <li>Talk about what has inspired you to fundraise.</li>
                    <li>“Save for Later” to continue editing later or click on “Publish” to share your fundraiser with the
                    world</li>
                </ul>`
            },
            {
                question: 'How can I donate to an existing fundraiser?',
                answer: `Please select “Support a Fundraiser” option on the top of the homepage. If you are looking for a specific fundraiser, 
                type in the fundraiser page name in the search bar.`
            },
            {
                question: 'How can I fundraise as a team?',
                answer: `Whilst setting up a fundraiser you have the option to fundraise “as an individual” or “in a team”.
                <br/><br/>
                Once you select fundraise in a team, you will be able to invite new team members who can collect
                donations on behalf of your fundraiser.`
            },
            {
                question: 'How can I post an update or edit/manage my fundraiser?',
                answer: `Begin by logging in to your account. Click on “Personal Fundraiser”. Select the fundraiser you wish to
                post an update to or edit.
                <br/><br/>
                For posting an update scroll down to the text box, here you can type a message or share pictures. Click “Submit” and your post will be shared on your page.
                <br/><br/>
                To edit a fundraiser, on the same page, click on “Edit Page” at the top right-hand corner and you will be able
                to make changes to the basic information of your fundraiser.
                <br/><br/>
                Please note: only owners of a fundraiser are allowed to post updates regardless of if the fundraiser is as an
                “individual” or as a “team”.`
            },

            {
                question: 'How is donating to a fundraiser different to donating on The Citizens Foundation website?',
                answer: `Any donation made to TCF’s fundraising page is for a specific cause and occasion whereas all donations to
                main website are a direct contribution to TCF.
                <br/><br/>
                The fundraising engine has been created to raise for specific goals only. For example, a fundraiser can be
                created for constructing a new school or supporting a certain number of children for a year.`
            },
            {
                question: 'How can I share my fundraiser with my friends and family?',
                answer: `Once you are logged in to your account, click on “Personal Fundraiser”. Select the fundraiser you wish to
                share. Once selected, the page will display a “SHARE” button on the right-hand side of the page. Once
                you click on “SHARE”, you will be able to post your fundraiser on your social media or by copying your
                fundraiser link you can share the link with friends and family.`
            },
            {
                question: 'Can I hide my fundraiser?',
                answer: `Yes, once you hide your fundraiser it will be longer be visible to the public. However, in case you wish to
                permanently hide your fundraiser please contact the TCF Head Office at: <a href="mailto:contact@tcfglobal.org">contact@tcfglobal.org</a>`
            },
            {
                question: 'Can I fundraise for myself?',
                answer: `You cannot fundraise for yourself as this platform has been created for the sole purpose of fundraising for
                TCF students and TCF schools.`
            },
            {
                question: 'Is there a deadline for my fundraiser?',
                answer: 'There are no deadlines for your fundraiser as long as it is active.'
            },
        ]
    },
    {
        type: 'Questions about Donations',
        data: [
            {
                question: 'Can I get a tax receipt for my donations?',
                answer: `Our receipt is eligible for tax benefits in the following countries:
                <br/><br/>
                <table width="300px" border = "1" cellpadding = "10">
                <thead>
                    <th>Country</th>
                    <th>Tax Benefits</th>
                </thead>
                <tr>
                    <td>Pakistan</td>
                    <td>
                        <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                        <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>Canada</td>
                    <td>
                        <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                        <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>Italy</td>
                    <td>
                        <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                        <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>Switzerland</td>
                    <td>
                        <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                        <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>UK</td>
                    <td>
                        <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                        <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                        </svg>
                    </td>
                </tr>
                <tr>
                    <td>USA</td>
                    <td>
                        <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                        <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                        </svg>
                    </td>
                </tr>
                </table>`
            },
            {
                question: 'Can I access my donated funds?',
                answer: 'You will not be able to access your donated funds as all money will go directly in to TCF accounts.'
            },
            {
                question: 'What payment methods are available for making donations?',
                answer: `The Citizens Foundation provides its donors multiple ways to donate. See below a table of payment
                methods available according to the countries you are donating from:
                <br/><br/>
                <table border = "1" cellpadding = "10">
                    <thead>
                        <th>Country</th>
                        <th>Credit/Debit Card</th>
                        <th>PayPal</th>
                        <th>Google Pay</th>
                        <th>Apple Pay</th>
                        <th>Bank Transfers</th>
                    <thead/>
                    <tr>
                        <td>Australia</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    
                    </tr>
                    <tr>
                        <td>Canada</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>Ireland</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>Italy</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>Netherlands</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>Norway</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>Pakistan</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>Switzerland</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>United Arab Emirates</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>United Kingdom</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="red" focusable="false" viewBox="0 0 24 24" title="Clear">
                            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                        </td>
                    </tr>
                    <tr>
                        <td>United States</td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                        <td>
                            <svg width="25px" fill="#00884C" focusable="false" viewBox="0 0 24 24" title="Check">
                            <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                            </svg>
                        </td>
                    </tr>

                </table>
                `
            },
            {
                question: 'How does TCF treat and process anonymous donations?',
                answer: `Anonymous donations will not be visible to the public, however, the shared donor information will be visible to
                the organization.`
            },
            {
                question: 'How can I access my donation history?',
                answer: `You can begin by logging in to your account. Next, you can click on the “Profile” tab and then select
                “Donation History”.`
            },
            {
                question: 'How does TCF ensure proper utilization of Zakat Funds?',
                answer: `All proceeds collected by TCF as Zakat are maintained in separate bank accounts at Islamic Banks in
                Pakistan. The funds are then utilized through the course of the year to educate deserving children. We
                have well defined SOPs governing our Zakat utilization. These SOPs have clearly been delineated by our
                Shariah team.
                <br/><br/>
                Currently, 30% of our operational expenses are met through the Zakat allocations, while the rest of the
                requirements are fulfilled through the general pool of funds. The percentage of funds going towards
                Zakat is carefully allocated based on the number of consent forms received by consenting and qualifying
                parents. Every quarter, a thorough review of Zakat expenses is carried out to ensure that Zakat is being
                apportioned correctly.`
            },
            {
                question: 'Is TCF’s Zakat collection process Shariah compliant?',
                answer: `TCF’s Zakat collection process is certified to be Shariah compliant. Our Zakat collection and
                disbursement procedures and structures have been reviewed thoroughly by our Shariah Advisor, who
                has issued a certificate confirming that we are Shariah Compliant. We aim to provide Muslims over the
                world a simple, transparent, and ethical way to invest in educating the less privileged children of
                Pakistan. <a target="_blank" href="https://view.publitas.com/the-citizens-foundation/shariah-approval-for-zakat/page/1">
                Click here for zakat compliance certificate</a>`
            },
            {
                question: 'Can Zakat be given to institutions?',
                answer: `Many people mistakenly believe that Zakat can only be given directly to individuals or families and not
                to organizations.
                <br/><br/>
                This is not true.
                <br/><br/>
                Zakat can be given to anyone who is ‘mustahiq’ or qualifies for receiving Zakat, either directly or
                through an organization or intermediary, provided the money is spent according to the rules stipulated
                by Islam. When it comes to formal education of the children of deserving parents, it is a noble act, as
                seeking and obtaining education is a beneficial pursuit for both self and society and Islam places great
                emphasis upon it.`
            },
        ]
    },
    {
        type: 'Questions about My Account',
        data: [
            {
                question: 'How can I update my account details?',
                answer: `Begin by logging in to your account. Click on “Profile”, select “Settings” to make changes to your profile
                photo, name, email address, phone number etc.`
            },
            {
                question: 'Where can I see my donation history?',
                answer: `You can begin by logging in to your account. Next, you can click on the “Profile” tab and then select
                “Donation History”.`
            },
        ]
    }

]